module.exports = __webpack_public_path__ + "img/article-card3.d7ac2956.png";